import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { AppConfigContext } from '@providers/AppConfigProvider';

interface CustomTabsProps {
  tabValue: number;
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export default function CustomTabs({ tabValue, handleChange }: CustomTabsProps): JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  return (
    <Box
      className={isMobile ? 'max-md:h-[52px]' : 'mx-24'}
      sx={{
        width: isMobile ? '100%' : undefined,
        borderBottom: 2,
        borderColor: '#00375F',
        backgroundColor: isMobile ? '#F7F7F7' : undefined,
        borderRadius: '2px',
      }}
    >
      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label="basic tabs example"
        TabIndicatorProps={{ style: { display: 'none' } }}
        centered={isMobile}
        sx={{
          '.Mui-selected': { backgroundColor: '#00375F' },
          marginLeft: isMobile ? undefined : '32px',
          minHeight: '50px',
          '@media (max-width:767px)': {
            '& .MuiTabs-flexContainer': {
              display: 'flex',
              justifyContent: 'space-between',
              gap: '8px',
            },
          },
        }}
        className="max-md:px-5 w-full"
      >
        <Tab
          label="都道府県から探す"
          id="tab-0"
          aria-controls="tabPanel-0"
          className="md:mr-2 max-md:w-[48.5%] text-sm text-white font-bold whitespace-nowrap"
          sx={{
            backgroundColor: '#B4B4B4',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            padding: tabValue === 0 ? '12px 30px' : '12px 30px 17px',
            minHeight: '40px',
            height: '46px',
            top: tabValue === 0 ? '4px' : '10px',
          }}
        />
        <Tab
          label="路線・駅から探す"
          id="tab-1"
          aria-controls="tabPanel-1"
          className="max-md:w-[48.5%] text-sm text-white font-bold whitespace-nowrap"
          sx={{
            backgroundColor: '#B4B4B4',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            padding: tabValue === 1 ? '12px 30px' : '12px 30px 17px',
            minHeight: '40px',
            height: '46px',
            top: tabValue === 1 ? '4px' : '10px',
          }}
        />
      </Tabs>
    </Box>
  );
}
